<!-- 回到顶部组件 -->
<template>
  <div>
    <div class="selece-area-mask" @click="doClose" v-if="visible"></div>
    <div class="selece-area" :style="{top: top+'px',left: left+'px'}" v-if="visible">

      <div class="top-div" @click.stop="stopClick">
        <div class="title"><span>选择城市</span></div>
        <el-autocomplete
          class="inline-input"
          v-model="state2"
          :fetch-suggestions="querySearch"
          placeholder="请输入内容"
          :trigger-on-focus="false"
          @select="handleSelect"
          style="height: 40px;"
        >
        <i class="el-icon-search el-input__icon"
          slot="prefix"
          @click="handleIconClick">
        </i>
      </el-autocomplete>
      </div>
      <div class="left-div" @click.stop="stopClick">
        <div :id="'area_'+item.area_id" class="item-div" :class="{'item_on':provinceNum==item.area_number}" v-for="(item,index) in provinceList" :key="index" @click="areaClickHandler(item)">
          <span>{{item.area_name}}</span>
          <i class="el-icon el-icon-arrow-right"></i>
        </div>
      </div>
      <div class="right-div" @click.stop="stopClick">
        <div :id="'area_'+item.area_id" class="item-div" :class="{'item_on':cityNum==item.area_number}" v-for="(item,index) in cityList" :key="index" @click="areaClickHandler(item)">
          <span>{{item.area_name}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getAllArea } from "@/api/user";
export default {
	data (){
    return{
      areaList: [],//省市列表
      cityList: [],//城市列表
      provinceList: [],//省列表
      provinceItem: '',
      provinceNum: '',
      cityNum: '',
      provinceId: '',
      cityId: '',
      restaurants: [],
      state2: '',
      top: 0,
      left:0,
    }
  },
  props: {
      value: {
        type: String,
        required: true,
        default:""
      },
      parentId: {
        type: [Number, String],
      },
      offsetTop: {
        type: Number,
        default: 0
      },
      offsetLeft: {
        type: Number,
        default: 0
      },
      visible: {
        type: Boolean
      },
      areaEl:{},
      exhibition_id: {
        type: [Number, String],
        default: null
      },
      userNature: {
          type:Number,
          default:null,
      }
  },
	mounted() {
    this.findAreaAll();

  },
	methods:{
    doClose() {
      // 触发父组件中的dialogVisibleEvent事件，并传递参数
      this.$emit('areaVisibleEvent', false);
    },
    stopClick(){
    },
    areaClickHandler(item){
      if(item.area_level == 1){
        this.provinceItem = item;
        this.provinceNum = item.area_number;
        this.provinceId = item.area_id;
        this.getCityList();
      }else if(item.area_level == 2){
        this.cityNum = item.area_number;
        this.cityId = item.area_id;
        this._value = this.provinceItem.area_name + ' ' + item.area_name;
        this.doClose();
      }
    },
    findAreaAll(){
      if(this.areaList.length == 0){
        let data = {
          exhibition_id:this.exhibition_id,
          user_nature: this.userNature
        }
        getAllArea(data).then((res) => {
          if (res.type == "1") {
            this.areaList = res.data;
            this.initData();
          }
        });
      }else{
        this.initData();
      }

    },
    initData(){
      if(this.areaList.length == 0){
        return;
      }
      let areaList = this.areaList;
      this.provinceList = [];
      for (var i = 0; i < areaList.length; i++) {
        if(areaList[i].area_level == 1){
          this.provinceList.push(areaList[i]);
        }
      }
      this.restaurants = this.loadAll();
      this.getProvinceItem();
    },
    getProvinceItem(){
      let name = '';
      if(this.value && this.value != ''){
        let province = this.value.split(' ')[0];
        for (var i = 0; i < this.areaList.length; i++) {
          let item = this.areaList[i];
          if(item.area_name == province){
            name = province;
            this.provinceItem = item;
            this.provinceNum = item.area_number;
            this.provinceId = item.area_id;
            break;
          }
        }
      }
      if(name == ''){
        this.provinceItem = this.provinceList[0];
        this.provinceNum = this.provinceList[0].area_number;
        this.provinceId = this.provinceList[0].area_id;
      }
      this.getCityList();
    },
    getCityList(){
      let _this = this;
      let cityAry = [];
      for (var i = 0; i < this.areaList.length; i++) {
        let item = this.areaList[i];
        if(item.area_level == 2 && item.parent_area_number == this.provinceNum){
          cityAry.push(item);
        }
      }
      this.cityList = cityAry;
      if(this.value && this.value != ''){
        let city = this.value.split(' ')[1];
        for (var i = 0; i < cityAry.length; i++) {
          let item = cityAry[i];
          if(item.area_name == city){
            this.cityNum = item.area_number;
            this.cityId = item.area_id;
            break;
          }
        }
      }
      this.$nextTick(function(){
        if(_this.provinceId != ''){
          let offset = $("#area_"+_this.provinceId).offset();
          if(offset){
            let parentTop = 0;
            let parentOffset = $('.selece-area .left-div').offset();
            parentTop = parentOffset.top;
            $('.selece-area .left-div').scrollTop(offset.top -parentTop);
          }
        }
        if(_this.cityId != ''){
          let offset = $("#area_"+_this.cityId).offset();
          if(offset){
            let parentTop = 0;
            let parentOffset = $('.selece-area .right-div').offset();
            parentTop = parentOffset.top;
            $('.selece-area .right-div').scrollTop(offset.top -parentTop);
          }
        }
     })
    },
    querySearch(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
    console.log("querySearch",results)
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    loadAll() {
      let loadAry = [];
      for (var i = 0; i < this.areaList.length; i++) {
        let item = this.areaList[i];
        if(item.area_level == 2){
          loadAry.push({
            value: item.area_name,
            area_name: item.area_name,
            area_number: item.area_number,
            area_level: item.area_level,
            parent_area_number: item.parent_area_number
          });
        }
      }
      return loadAry;
    },

    handleIconClick(ev) {
      console.log('handleIconClick',ev);
    },
    handleSelect(item) {
      for (var i = 0; i < this.areaList.length; i++) {
        let area = this.areaList[i];
        if(area.area_level == 1 && area.area_number == item.parent_area_number){
          this.provinceItem = area;
          this.provinceNum = area.area_number;
          this.provinceId = area.area_id;
          this.getCityList();
          break;
        }
      }
      this.cityNum = item.area_number;
      this.cityId = item.area_id;
      this._value = this.provinceItem.area_name + ' ' + item.area_name;
      this.doClose();
    }
	},
  watch: {
      visible:function(val) {
          if(val){
            this.state2 = '';
            let _this = this;
            let parentTop = 0;
            let parentLeft = 0;
            console.log("------parentId------",this.parentId)
            if(this.parentId){
              let parentOffset = $('#'+this.parentId).offset();
            console.log("------parentOffset------",parentOffset)
              parentTop = parentOffset.top;
              parentLeft = parentOffset.left;
            }

            let offset = $(_this.areaEl).offset();
            let height = $(_this.areaEl).outerHeight();
            console.log(offset,height)
            _this.top = offset.top + height + 10 - parentTop + this.offsetTop;
            _this.left = offset.left - parentLeft + this.offsetLeft;
            this.initData();
          }
      }
  },
  computed: {
    _value: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  }
}
</script>
<style>
  .selece-area .top-div .el-input__inner{
    height: 35px;
    line-height: 35px;
    width: 217px!important;
  }
  .selece-area .el-input{
    width: 217px!important;
  }
  .el-autocomplete-suggestion{
    z-index: 999999!important;
  }
</style>
<style scoped>
.selece-area-mask{
  position: fixed;
  z-index: 99998;
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0px;
}
.selece-area{
  position: absolute;
  z-index: 99999;
  width: 434px;
  height: 410px;
  background: #ffffff;
  box-shadow: 0px 0px 5px #c1c1c1;
}
.selece-area .top-div{
  height: 50px;
  line-height: 50px;
}
.selece-area .top-div span{
  font-size: 16px;
  font-weight:bold;
  padding-left: 20px;
}
.selece-area .top-div .title{
  width: 200px;
  display: inline-block;
}
.selece-area .left-div{
  width: 200px;
  height: 360px;
  float: left;
  overflow-y: auto;
  overflow-x: hidden;
}
.selece-area .left-div::-webkit-scrollbar {
  display: none;
}
.selece-area .right-div::-webkit-scrollbar {
  display: none;
}
.selece-area .right-div{
  width: 229px;
  height: 360px;
  border-left: 1px solid #EDEDEE;
  float: left;
  overflow-y: auto;
  overflow-x: hidden;
}
.selece-area .item-div{
  width: 100%;
  height: 40px;
  line-height: 40px;
  overflow: hidden;
  position: relative;
}
.selece-area .item-div .el-icon{
  position: absolute;
  z-index: 99;
  right: 10px;
  top: 10px;
}
.selece-area .item-div:hover{
  background: #F1F8FE;
}
.selece-area .item_on{
  background: #F1F8FE;
}
.selece-area .item-div span{
  padding-left: 20px;
}
</style>
